module.exports = __webpack_public_path__ + "img/超高频柔性.d8dfe4d3.jpg";